import { workspaceDb } from '../db/db';
import Dao from './dao';

export default class WorkspaceDao extends Dao {
  db() {
    return workspaceDb.db();
  }
}
